import { Component, OnInit } from '@angular/core';
import { FeriadosService, FeriadoActualizado, Feriado, FeriadoResponse } from './feriados.service';
import { AuthService } from '../../auth/auth.service';
import { MenuService } from '../menu/menu.service';
import { Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { EditarFeriadoDialogComponent } from '../components/editar-feriado-dialog/editar-feriado-dialog.component';
import { DuplicarFeriadosDialogComponent } from '../components/duplicar-feriados-dialog/duplicar-feriados-dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-feriados',
  templateUrl: './feriados.component.html',
  styleUrls: ['./feriados.component.scss']
})
export class FeriadosComponent implements OnInit {
  static instancia: FeriadosComponent;
  feriadosBD: FeriadoResponse;
  feriadosTemporales: FeriadoActualizado[] = [];

  loading: boolean = false;
  cambiosPendientes: boolean = false;
  nombre: string = '';
  selectedDate: Date;
  model_value: string = '';
  mensaje_error_descripcion: string = '';
  mensaje_error_fecha: string = '';
  pageSize = 25;
  currentPage = 1;

  constructor(private dialog: MatDialog, private feriadosService: FeriadosService, private authService: AuthService, private menuService: MenuService, private router: Router) {
    FeriadosComponent.instancia = this;
  }

  ngOnInit() {
    this.loadFeriados();
      window.addEventListener('beforeunload', this.onBeforeUnload);
  }

  ngOnDestroy() {
    window.removeEventListener('beforeunload', this.onBeforeUnload);
  }
 
  onBeforeUnload(event: BeforeUnloadEvent) {
    // Este mensaje personalizado puede no mostrarse en todos los navegadores
    event.preventDefault();
    alert("test")
  }

  salirAdministrador() {
    this.menuService.salirAdministrador();
    this.router.navigate(["/login"]);
  }

  volver() {
    this.router.navigate(['/config/home']);
  }

  loadFeriados() {
    this.feriadosService.getFeriados().subscribe(
      (data: FeriadoResponse) => {
        this.feriadosBD = data;
      },
      (error) => {
        console.error('Error al obtener feriados', error);
      }
    );
  }


  //++++++paginado++++++

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex + 1;
  }


  get totalPages(): number {
    return Math.ceil(this.getAllFeriados().length / this.pageSize);
  }

  // feriados locales + feriadosBD en una sola lista
  getAllFeriados() {
    const idsModificados = this.feriadosTemporales
      .filter(f => (f.accion === 'M' || f.accion === 'B') && f.id != null)
      .map(f => f.id);

    const bd = this.feriadosBD?.content
      ?.filter(f => !idsModificados.includes(f.id))
      .map(f => ({ ...f, tipo: 'bd', nombre: f.nombre, fecha: f.fecha, fechaCreacion: f.fechaCreacion })) || [];

    const locales = this.feriadosTemporales
      .filter(f => f.accion !== 'B') // Excluir los borrados
      .map(f => ({
        ...f,
        tipo: 'local',
        nombre: f.nombre,
        fecha: f.fecha,
      }));

    return [...locales, ...bd];
  }



  // Obtengo los feriados que se deben mostrar según la página actual
  get paginatedFeriados() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.getAllFeriados().slice(start, end);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) this.currentPage++;
  }

  prevPage() {
    if (this.currentPage > 1) this.currentPage--;
  }

  //++++++++++ fin paginado+++++

  getCurrentUser(): string {
    return this.authService.getUser().username;
  }

  getFechaActual(): Date {
    return new Date();
  }

  addFeriados() {
    const valido = this.validateForm();

    if (!valido) {
      return;
    }

    const date = new Date(this.selectedDate);
    this.feriadosTemporales.push({
      fecha: date,
      nombre: this.nombre,
      accion: 'A',
      fechaActualizacion: this.getFechaActual(),
      usuarioActualizacion: this.getCurrentUser()
    });
    this.cambiosPendientes = true;
    this.clearForm();
  }

  clearForm() {
    this.selectedDate = null;
    this.nombre = '';
    this.mensaje_error_descripcion = '';
    this.mensaje_error_fecha = '';
  }

  validateForm(): boolean {
    let valido = true;

    if (!this.nombre || this.nombre.trim().length === 0) {
      this.mensaje_error_descripcion = 'La descripción no puede estar vacía';
      valido = false;
    } else {
      this.mensaje_error_descripcion = '';
    }

    if (!this.selectedDate) {
      this.mensaje_error_fecha = 'Debe seleccionar una fecha';
      valido = false;
    } else {
      this.mensaje_error_fecha = '';
    }

    return valido;
  }

  editarFeriado(index: number, tipo: 'local' | 'bd') {
    const feriado = tipo === 'local'
      ? this.feriadosTemporales[index]
      : this.feriadosBD.content[index];


    const dialogRef = this.dialog.open(EditarFeriadoDialogComponent, {
      width: '400px',
      data: {
        fecha: feriado.fecha,
        nombre: feriado.nombre
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (tipo === 'local') {

          this.feriadosTemporales[index] = {
            ...this.feriadosTemporales[index],
            fecha: result.fecha,
            nombre: result.nombre,
            accion: 'A',
            fechaActualizacion: this.getFechaActual(),
            usuarioActualizacion: this.getCurrentUser()
          };


        } else if (tipo === 'bd') {
          this.feriadosBD.content[index] = {
            ...this.feriadosBD.content[index],
            ...result
          };

          const original = this.feriadosBD.content[index];
          const indexTemp = this.feriadosTemporales.findIndex(f => f.id === original.id);

          const feriadoModificado: FeriadoActualizado = {
            id: original.id,
            fecha: result.fecha,
            nombre: result.nombre,
            accion: 'M',
            fechaCreacion: original.fechaCreacion,
            fechaActualizacion: this.getFechaActual(),
            usuarioActualizacion: this.getCurrentUser()
          };

          if (indexTemp !== -1) {
            this.feriadosTemporales[indexTemp] = feriadoModificado;

          } else {
            this.feriadosTemporales.push(feriadoModificado);
          }
        }
        this.cambiosPendientes = true;
      }
    });
  }




  duplicar() {
    const dialogRef = this.dialog.open(DuplicarFeriadosDialogComponent, {
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const { origen, destino } = result;
        console.log('Duplicar de', origen, 'a', destino);

        this.feriadosService.duplicarFeriados(origen, destino).subscribe({
          next: () => {
            console.log('Feriados duplicados exitosamente');
            this.loadFeriados();
          },
          error: (err) => {
            console.error('Error al duplicar feriados:', err);
            alert('Ocurrió un error al duplicar los feriados.');
          }
        });
      }
    });
  }



  deleteFeriados(index: number, tipo: 'local' | 'bd') {
    if (tipo === 'local') {
      const feriado = this.feriadosTemporales[index];
      this.feriadosTemporales.splice(index, 1);

      // Eliminar de lista temporal si tiene marca A
      const idx = this.feriadosTemporales.findIndex(f => f.fecha === feriado.fecha && f.accion === 'A');
      if (idx !== -1) {
        this.feriadosTemporales.splice(idx, 1);
      }
    } else {
      const feriado = this.feriadosBD.content[index];
      this.feriadosBD.content.splice(index, 1);

      const yaMarcado = this.feriadosTemporales.some(f => f.id === feriado.id);
      if (!yaMarcado) {
        const feriadoEliminado: FeriadoActualizado = {
          id: feriado.id,
          fecha: feriado.fecha,
          nombre: feriado.nombre,
          accion: 'B',
          fechaActualizacion: this.getFechaActual(),
          usuarioActualizacion: this.getCurrentUser()
        };
        this.feriadosTemporales.push(feriadoEliminado);
      }

    }
    this.cambiosPendientes = true;

  }

  saveFeriados() {
    const listaParaEnviar = this.feriadosTemporales.map(f => ({
      ...(f.id && { id: f.id }), // solo agrega id si existe
      nombre: f.nombre,
      fecha: f.fecha instanceof Date ? f.fecha.toISOString().split('T')[0] : f.fecha,
      fechaActualizacion: f.fechaActualizacion instanceof Date
        ? f.fechaActualizacion.toISOString()
        : f.fechaActualizacion,
      fechaCreacion: f.fechaCreacion instanceof Date
        ? f.fechaCreacion.toISOString()
        : f.fechaCreacion,
      accion: f.accion,
      usuarioActualizacion: f.usuarioActualizacion
    }));


    console.log('Lista para enviar al backend:', listaParaEnviar);
    console.log('Enviando al backend:', JSON.stringify(listaParaEnviar, null, 2));

    this.loading = true;
    this.feriadosService.guardarCambios(listaParaEnviar).subscribe(
      () => {
        alert('Cambios guardados correctamente.');
        this.feriadosTemporales = [];
        this.loadFeriados();
        this.loading = false;
        this.cambiosPendientes = false;
      },
      (error) => {
        this.loading = false;
        console.error('Error al guardar los feriados', error);
      }
    );
  }

  public hayCambiosSinGuardar(): boolean {
    return this.feriadosTemporales.length > 0;
  }

  public guardarDesdeNavegacion(callback?: () => void): void {
  const listaParaEnviar = this.feriadosTemporales.map(f => ({
    ...(f.id && { id: f.id }),
    nombre: f.nombre,
    fecha: f.fecha instanceof Date ? f.fecha.toISOString().split('T')[0] : f.fecha,
    fechaActualizacion: f.fechaActualizacion instanceof Date
      ? f.fechaActualizacion.toISOString()
      : f.fechaActualizacion,
    fechaCreacion: f.fechaCreacion instanceof Date
      ? f.fechaCreacion.toISOString()
      : f.fechaCreacion,
    accion: f.accion,
    usuarioActualizacion: f.usuarioActualizacion
  }));

  this.loading = true;
  this.feriadosService.guardarCambios(listaParaEnviar).subscribe(
    () => {
      alert('Cambios guardados correctamente.');
      this.feriadosTemporales = [];
      this.loadFeriados();
      this.loading = false;
      this.cambiosPendientes = false;

      if (callback) callback(); 
    },
    (error) => {
      this.loading = false;
      console.error('Error al guardar los feriados', error);
    }
  );
}






}
